import toast from "react-hot-toast";
import * as api from "../Api";
import { getAllUnapprovedInsurance } from "./unApprovedInsurance";

export const errorText = (error) =>
  error?.response?.data?.message || error?.message || "Something went wrong";

// Resolves true when saved, so the form knows whether to close
export const createNewInsurance = (postData) => async (dispatch) => {
  const creatingId = toast.loading("Submitting insurance...");
  try {
    const { data } = await api.createInsurance(postData);
    dispatch({ type: "NEW_INSURANCE", payload: data });
    // It now waits for approval
    dispatch(getAllUnapprovedInsurance());
    toast.success("Insurance submitted for approval", { id: creatingId });
    return true;
  } catch (error) {
    toast.error(errorText(error), { id: creatingId });
    return false;
  }
};

export const getInsurance = () => async (dispatch) => {
  try {
    const { data } = await api.getAllInsurance();
    dispatch({ type: "GET_ALL_INSURANCE", payload: data });
  } catch (error) {
    dispatch({ type: "LOAD_FAILED", failed: "GET_ALL_INSURANCE" });
    toast.error(errorText(error));
  }
};
